import { useCallback, useSyncExternalStore } from 'react';

// mirrors Tailwind's `md` breakpoint (the `max-md:` variants used in class names); change both together
export const MOBILE_MEDIA_QUERY = '(width < 48rem)';

// one MediaQueryList per query, shared by every subscriber
const mediaQueryLists = new Map<string, MediaQueryList>();

const getMediaQueryList = (query: string) => {
    let list = mediaQueryLists.get(query);
    if (!list) {
        list = window.matchMedia(query);
        mediaQueryLists.set(query, list);
    }
    return list;
};

const useMediaQuery = (query: string) => {
    const subscribe = useCallback(
        (onChange: () => void) => {
            const list = getMediaQueryList(query);
            list.addEventListener('change', onChange);
            return () => list.removeEventListener('change', onChange);
        },
        [query]
    );

    return useSyncExternalStore(subscribe, () => getMediaQueryList(query).matches);
};

export default useMediaQuery;
